import {
  Divider,
  styled,
  Stack,
} from "@mui/material";
import {
  KeyboardBackspace,
  ArrowRightAlt,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { leftMenuSelector } from "Selectors/leftMenuSelector";
import {
  toggleSecondaryMenu,
} from "Actions";
import { motion } from "motion/react";
import { Box } from "@mui/system";
import {
  LeftMenuItem,
} from "features/leftMenu";


export const LeftMenuExtras = ({
  children,
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <Box>
      <Box>{children}</Box>
    </Box>
  );
};

export const LeftMenuToggleButton = ({
  backToSecondaryText,
}: {
  backToSecondaryText: string;
}) => {
  const { isSecondaryOpen, isMenuOpen, debouncedIsHover } =
    useSelector(leftMenuSelector);
  const dispatch = useDispatch();

  return (
    <motion.div animate={isMenuOpen || debouncedIsHover ? "open" : "closed"}>
      <motion.div
        variants={{
          open: {
            x: 0,
          },
          closed: {
            x: -12,
          },
        }}
      >
        <LeftMenuItem
          icon={isSecondaryOpen ? KeyboardBackspace : ArrowRightAlt}
          to="#"
          text={isSecondaryOpen ? "Back to menu" : backToSecondaryText}
          onClick={() => dispatch(toggleSecondaryMenu())}
        />
      </motion.div>
    </motion.div>
  );
};
export const LeftMenuExtrasTitle = ({
  children,
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <Box>
      <Box>{children}</Box>
      <Divider />
    </Box>
  );
};
export const LeftMenuBlock = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "densePadding",
})<{ densePadding?: boolean }>(({ densePadding }) => ({
  padding: densePadding ? "0 5px" : "0 18px",
  color: "white",
}));


export const LeftMenuExtrasInner = ({
  children,
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <Box
      key="extra"
      component={motion.div}
      initial={{ x: 50 }}
      animate={{ x: 0 }}
      exit={{ x: 50 }}
    >
      {children}
    </Box>
  );
};
